import { render, staticRenderFns } from "./LineChartNewInactiveClients.vue?vue&type=template&id=b0928990&scoped=true&lang=pug&"
import script from "./LineChartNewInactiveClients.vue?vue&type=script&lang=ts&"
export * from "./LineChartNewInactiveClients.vue?vue&type=script&lang=ts&"
import style0 from "./LineChartNewInactiveClients.vue?vue&type=style&index=0&id=b0928990&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0928990",
  null
  
)

export default component.exports